/*
 * MarketPage Messages
 *
 * This contains all the text for the MarketPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.MarketPage';

export default defineMessages({
  mart: {
    id: `${scope}.mart`,
    defaultMessage: 'Chợ',
  },
  addToCart: {
    id: `${scope}.addToCart`,
    defaultMessage: 'Thêm vào giỏ',
  },
  notFound: {
    id: `${scope}.notFoundProduct`,
    defaultMessage: 'Rất tiếc, không tìm thấy sản phẩm phù hợp với kết quả tìm kiếm',
  },
  notFoundDescription: {
    id: `${scope}.notFoundDescription`,
    defaultMessage: 'Chúng tôi không tìm thấy sản phẩm nào',
  },
  readMore: {
    id: `${scope}.readMore`,
    defaultMessage: 'Xem thêm',
  },
  collapse: {
    id: `${scope}.collapse`,
    defaultMessage: 'Thu gọn',
  },
  backToHome: {
    id: `${scope}.backToHome`,
    defaultMessage: 'Về trang chủ',
  },
  requestSellProduct: {
    id: `${scope}.requestSellProduct`,
    defaultMessage: 'Yêu cầu bán sản phẩm',
  },
  youMayAlsoLike: {
    id: `${scope}.youMayAlsoLike`,
    defaultMessage: 'Có thể bạn quan tâm',
  },
  sortBy: {
    id: `${scope}.sortBy`,
    defaultMessage: 'Sắp xếp theo',
  },
  origins: {
    id: `${scope}.origins`,
    defaultMessage: 'Xuất xứ',
  },
  brand: {
    id: `${scope}.brand`,
    defaultMessage: 'Thương hiệu',
  },
  allOption: {
    id: `${scope}.allOption`,
    defaultMessage: 'Tất cả',
  },
  bestSeller: {
    id: `${scope}.bestSeller`,
    defaultMessage: 'Bán chạy',
  },
  newest: {
    id: `${scope}.newest`,
    defaultMessage: 'Mới nhất',
  },
  ascPrice: {
    id: `${scope}.ascPrice`,
    defaultMessage: 'Giá tăng dần',
  },
  descPrice: {
    id: `${scope}.descPrice`,
    defaultMessage: 'Giá giảm dần',
  },
  categories: {
    id: `${scope}.categories`,
    defaultMessage: 'Danh mục',
  },
  filterButton: {
    id: `${scope}.filterButton`,
    defaultMessage: 'Lọc',
  },
  clearFilterButton: {
    id: `${scope}.clearFilterButton`,
    defaultMessage: 'Xóa lọc',
  },
  advancedFilter: {
    id: `${scope}.advancedFilter`,
    defaultMessage: 'Bộ lọc nâng cao',
  },
  clearButton: {
    id: `${scope}.clearButton`,
    defaultMessage: 'Xóa lọc',
  },
  all: {
    id: `${scope}.all`,
    defaultMessage: 'Tất cả',
  },
  brandsPlaceHolder: {
    id: `${scope}.brandsPlaceHolder`,
    defaultMessage: 'Chọn thương hiệu',
  },
  categoriesPlaceHolder: {
    id: `${scope}.categoriesPlaceHolder`,
    defaultMessage: 'Chọn danh mục',
  },
});
